'use client'

import { GET_ASSIGNED_PERSONAS_QUERY_KEY } from '@partment/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'
import { useState } from 'react'
import { getPersonas } from '..'

export const usePersonasStatus = () => {
  const { data: session, status } = useSession()

  const {
    data: personasData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [GET_ASSIGNED_PERSONAS_QUERY_KEY],
    queryFn: getPersonas,
    enabled: status === 'authenticated' && Boolean(session?.access_token),
    retry: false,
  })

  const [opened, setOpened] = useState(false)

  return {
    data: personasData?.data?.personas ?? [],
    isLoading,
    isError,
    opened,
    setOpened,
  }
}
